export const setFilter = (filter: any) => ({
    type: 'SET_FILTER',
    payload: filter,
  });
  